module.exports = __webpack_public_path__ + "static/logo-saretec-a808091c532eedb97b59f800dfeb1160.png";